import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IFormFieldType } from "../../../types/api/dynamic-form";

export async function detailFiled(
  id: string
): Promise<AxiosResponse<TResponse<IFormFieldType>>> {
  return axios.get(`${API_ENDPOINTS.DYNAMIC_FORM_DETAIL}/${id}`);
}

export async function fieldList(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<IFormFieldType[]>>> {
  return axios.get(API_ENDPOINTS.DYNAMIC_FORM_LIST, {
    params: qData,
  });
}

export async function createField(
  payload: IFormFieldType
): Promise<AxiosResponse<TResponse<IFormFieldType>>> {
  return axios.post(API_ENDPOINTS.DYNAMIC_FORM_CREATE, payload);
}

export async function deleteField(
  _id: string
): Promise<AxiosResponse<TResponse<IFormFieldType>>> {
  return axios.put(`${API_ENDPOINTS.DYNAMIC_FORM_DELETE}/${_id}`);
}
